import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function SynchronizeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 26 25" htmlColor={props.color? props.color : '#67707E'}>
      <g fill="none">
        <path
          d="M8.25 1H16.5C18.1569 1 19.5 2.34315 19.5 4V10.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 17.5H7.5C5.84315 17.5 4.5 16.1569 4.5 14.5V7.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 6.99707L19.5 10.7471L23.25 6.99707"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 11.4971L4.5 7.74707L0.75 11.4971"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
